'use strict'

import React from 'react';

import priority from '../../app/utils/priority.js';

class PrioirtyItem extends React.Component {
  render() {
    return this.props.items.length>1 && this.props.showId!==true ? (
      <div style={{paddingTop:2}}>
        <span>...</span>
      </div>
    ) : this.props.items.length===1 || this.props.showId===true ? (
      <div style={{paddingTop:5, color: this.props.items[0].readOnly ? "#505050" : undefined}}>{this.props.items[0].no || this.props.no}</div>
    ) : null;
  }
}

class PriorityTableEntryDisplay extends React.Component {
  selectItem() {
    this.props.onSelect(this.props);
  }
  render() {
    var item=this.props;
    return(
      <div key={item.id} style={{paddingBottom: 3}}>
        {this.props.onSelect!==undefined && this.props.readOnly!==true ? <a href="#" onClick={this.selectItem.bind(this)}>{item.no}</a> : item.no} {item.title}{item.proximity!==undefined ? <span> ({item.proximity})</span> : null}
      </div>
    );
  }
}

class PriorityMarker extends React.Component {
  constructor(props) {
    super(props);
    this.state={tip:false};
  }

  showTip(event) {
    event.preventDefault();
    this.setState({tip:!this.state.tip});
  }

  render() {
    var border="solid 1px white";
    var background="#ffffff";
    var color="#212121";
    var opacity=1;
    if (this.props.items.length===1 && this.props.items[0].style==="faded") {
      border="dashed 1px grey";
      background="#e6e6e6";
      color="grey";
      opacity=0.7;
    }

    return (this.props.items.length>0) ? (
      <div onClick={this.props.preventDetails===true ? null : this.showTip.bind(this)} style={{cursor: "pointer", position:"relative", display:"inline-block", border:border, borderRadius:30, height: 30,width:30, backgroundColor:background, color:color, opacity:opacity, textAlign:"center"}}>
        <PrioirtyItem {...this.props} items={this.props.items}/>
          {this.state.tip
            ? (
              <div onClick={this.showTip.bind(this)} style={{position:"absolute", border:"1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, textAlign:"left", left: 10, padding: 10, zIndex:1, width:250, backgroundColor:"white"}}>
                {this.props.items.map((item,index)=><PriorityTableEntryDisplay key={index} {...item} onSelect={this.props.onSelect}/>)}
              </div>
            ) : null
          }
      </div>
    ) : null;
  }
}

class PriorityCell extends React.Component {
  selected(event) {
    if (this.props.onClick!==undefined) {
      this.props.onClick({target: {value:{row:this.props.row,column:this.props.column}}});
    }
  }
  render() {
    return (
      <td onClick={this.selected.bind(this)} style={{textAlign:"center", verticalAlign:"middle", width:this.props.size, height:this.props.size,backgroundColor:priority.priorityColor(this.props.color,this.props.profile)}}>
        <PriorityMarker {...this.props}/>
      </td>
    );
  }
}

class PriorityRow extends React.Component {
  render() {
    var size=this.props.size;
    var items=this.props.items;
    return (
      <tr>
        {this.props.colors.map((cellColor,index)=><PriorityCell {...this.props} key={index} size={size} color={cellColor} onSelect={this.props.onSelect} items={items.filter(item=>item.column===index+1)} column={index+1}/>)}
      </tr>
    );
  }
}

export default class PriorityTable extends React.Component {
  render() {
    let labels=this.props.labels;
    var size=40;
    var items=this.props.items.filter(item=>item.status!=="Closed");
    let probabilityLabelStyle=Object.assign({},{width: (size+4)*5+2, fontWeight: "bold", textAlign:"center", display:"inline-block", transform: "rotate(-90deg)",transformOrigin: "left top 0", WebkitTransform: "rotate(270deg)",  MozTransform: "rotate(270deg)", MsTransform: "rotate(270deg)", OTransform: "rotate(270deg)"},this.props.settings!==undefined ? this.props.settings.riskTable : {});
    let rowCount=5;
    return (
      <div>
        <div style={{display:"inline-block", position:"relative", width:20}}>
          <div style={probabilityLabelStyle}>
            {labels.row}
          </div>
        </div>
        <div style={{display:"inline-block"}}>
          <table>
            <tbody>
              {priority.getTableColors(rowCount,this.props.profile).map((row,index)=>(
                <PriorityRow key={row.label} {...this.props} onSelect={this.props.onSelect} id={row.label} label={row.label} size={size} colors={row.colors} row={rowCount-index}
                  items={items.filter(item=>item.row===row.value)}/>
              ))}
            </tbody>
          </table>
          <div style={{textAlign:"center", fontWeight:"bold"}}>
            {labels.column}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/PriorityTable.jsx